import React from 'react';
import { Table, ScrollArea, useMantineTheme, Text } from '@mantine/core';

import { safeValue, sqlDateToHumanDate } from "../../utils/globalFunctions";

import THSort from "../../components/general/THSort";
import THPlain from "../../components/general/THPlain";

const GaransiHistoryTable = ({
    stateData,
    stateSortList,
    stateSortSelected,
    fnSort,
    stateDataOffset,
    fnSelectedData
}) => {

    const theme = useMantineTheme();

    const TD = ({ children, stateNoWrap = true }) => {
        return (
            <td
                style={{
                    whiteSpace: stateNoWrap ? 'nowrap' : 'normal',
                    color: theme.colorScheme === 'light' ? theme.colors.gray[7] : theme.colors.gray[6],
                }}
            >
                {children}
            </td>
        )
    }

    return (
        <ScrollArea>
            <Table
                highlightOnHover
                verticalSpacing="sm"

                sx={() => ({
                    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[8],

                    '& thead.tableHeadSticky': {
                        position: 'sticky',
                        top: '0px',
                    },

                    '& thead tr th': {
                        paddingTop: theme.spacing.sm,
                        paddingBottom: theme.spacing.sm,
                    },
                    '& thead tr th.THSort:hover': {
                        backgroundColor: `${theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[5]} !important`
                    },
                    '& thead tr th:not(:nth-last-of-type(1)) .wrapperContentTH': {
                        borderRight: `1px solid ${theme.colorScheme === 'light' ? theme.colors.gray[4] : theme.colors.dark[4]}`,
                    },
                })}
            >
                <thead>
                    <tr>
                        <THPlain stateCaption='No' />

                        <THSort
                            stateSortInUse={stateSortList.categoryName}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THSort
                            stateSortInUse={stateSortList.categorySubName}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THPlain stateCaption='Serial Number' />

                        <THSort
                            stateSortInUse={stateSortList.supplierName}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THSort
                            stateSortInUse={stateSortList.garansiJumlah}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THSort
                            stateSortInUse={stateSortList.tanggalPengajuan}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THSort
                            stateSortInUse={stateSortList.teknisiPengaju}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THPlain stateCaption='Keterangan' />
                    </tr>
                </thead>

                <tbody>
                    {Object.keys(stateData).map((key, index) => {
                        return (
                            <tr
                                key={key}
                                style={{
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    fnSelectedData(stateData[key]);
                                }}
                            >
                                <TD>{Number(stateDataOffset) + Number(index) + 1}</TD>

                                <TD>{stateData[key].stock_category_name}</TD>

                                <TD>{stateData[key].stock_category_sub_name}</TD>

                                <TD>{safeValue(stateData[key].stock_serial_number, '-')}</TD>

                                <TD>{stateData[key].supplier_name}</TD>

                                <TD>{stateData[key].jumlah_detil}</TD>

                                <TD>
                                    {sqlDateToHumanDate({
                                        stateDate: stateData[key].stock_garansi_tanggal_pengajuan,
                                        stateWithTime: false,
                                        stateLang: 'id',
                                        stateIsShort: false,
                                        stateDay: false,
                                        stateDefaultValue: ' - ',
                                        stateDateType: 'day'
                                    })}
                                </TD>

                                <TD>{safeValue(stateData[key].stock_garansi_pengaju_user_name, '-')}</TD>

                                <TD stateNoWrap={false}>
                                    <Text lineClamp={2}>{safeValue(stateData[key].stock_garansi_info, '-')}</Text>
                                </TD>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </ScrollArea>
    )
}

export default React.memo(GaransiHistoryTable);